// extracted by mini-css-extract-plugin
export default {"left":"CaseFormContent_left__5uYzX"};